export const AUTO_CODE_OFF = { value: -1, label: 'OFF' };
